import React from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router";
import HeaderBox from "../../reuseableComponents/headerBox";

import BacteriologicalMonitoringTable from "./BacteriologicalMonitoringTable";
import ChlorineResidualMonitoringTable from "./ChlorineResidualMonitoringTable";
import DisinfectionByProductStage2MonitoringTable from "./DisinfectionByProductStage2MonitoringTable";
import OtherDistributionMonitoringTable from "./OtherDistributionMonitoringTable";
import MonitoringRequirementsByFacilityTable from "./MonitoringRequirementsByFacilityTable";
import GroupedSamplingStationTable from "./../inventoryReport/GroupedSamplingStationTable";
import OpenComplianceScheduleTable from "./OpenComplianceScheduleTable";

const MonitoringScheduleReport = () => {
  let { systemId } = useParams();

  return (
    <>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='monitoringScheduleReport'>
            <h3 style={{ color: "#fff" }}>Water System Monitoring Schedules</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Bacteriological Monitoring</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <BacteriologicalMonitoringTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Disinfection ByProduct Stage 2 Monitoring</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <DisinfectionByProductStage2MonitoringTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Other Distribution Monitoring</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <OtherDistributionMonitoringTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Chlorine Residual Monitoring</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <ChlorineResidualMonitoringTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Monitoring Requirements By Facility</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <MonitoringRequirementsByFacilityTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Grouped Source Sampling Stations</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <GroupedSamplingStationTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Open Compliance Schedules</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <OpenComplianceScheduleTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
    </>
  );
};

export default MonitoringScheduleReport;
